import { PricingSlotsTranslation } from 'locales/de/pages/PricingTable/pricingslots';

const en: PricingSlotsTranslation = {
  suffix: ' per Ad',
  header: 'Jobmarket Pricing',
  subheader: '2 months visible',
  linktext: 'To view the prices for advertisements in the job market click ',
  actuallink: 'here. ',
  buttontext: 'Register here',

  freeTitle: 'Free',
  freePrice: '0€',
  freeBenefit1: 'Student Employee',
  freeBenefit2: '(Final) Thesis',
  freeBenefit3: 'Abroad internship',
  freeBenefit4: 'Internship',
  freeBenefit5: 'Dual Study',
  freeBenefit6: 'Tutoring',
  freeBenefit7: 'Student Assistant',
  freeBenefit8: 'Volunteer',

  payTitle: 'Payment',
  payPrice: '80€',
  payBenefit1: 'Entry-level jobs and trainees',
  payBenefit2: 'Student Job',
  payBenefit3: 'Position requiring inital work experience'
};

export default en;
